import { render, staticRenderFns } from "./NachbestellungBestaetigen.vue?vue&type=template&id=895dc064"
import script from "./NachbestellungBestaetigen.vue?vue&type=script&lang=ts"
export * from "./NachbestellungBestaetigen.vue?vue&type=script&lang=ts"
import style0 from "./NachbestellungBestaetigen.vue?vue&type=style&index=0&id=895dc064&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports